import { Injectable, inject } from '@angular/core';
import { ClaimsToken, HttpService } from 'eas-core-lib';
import { armEnvironment } from 'src/environments/arm.environment';
import { BehaviorSubject, Observable, Subject, map, of, retry, tap } from 'rxjs'
import { UtilityContext } from 'eas-core-lib/utilities';
import { Docs } from 'eas-core-lib/utilities/models/docs';
import { JoinAccountRequestToFlag, ManualApprovalModel, ProfileApporvalDetails } from '../models/profile-approval-details.model';
import { ProfileSearchRequest, ProfileSearchResponse } from '../models/profile-search.model';
import { ChangeRequestSearchDataResponse } from '../models/change-profile-approval.model';
import { ChangeApprovalDetails, ManualChangeApprovalModel } from '../models/change-profile-approval-details.model';
import { ChangeProfileSearchData } from '../models/change-profile-search.model';
import { MicroAppData } from '../models/microapp.model';

@Injectable({
    providedIn: 'root',
})

export class ChangeProfileApprovalService {
    private http = inject(HttpService);
    private profileApprovalComponentSwitches = new BehaviorSubject<any>({});
    private changeProfileAccountRequestDetails = new BehaviorSubject<ChangeApprovalDetails>({} as ChangeApprovalDetails);

    private duplicatePersonRecords = new BehaviorSubject<any>({});
    selectedComponents = this.profileApprovalComponentSwitches.asObservable();
    changeProfileApprovalComponents = this.changeProfileAccountRequestDetails.asObservable();
    duplicatePersonInfo = this.duplicatePersonRecords.asObservable();
    //   public claimsToken: ClaimsToken;
    public changeApprovalDetails: ChangeApprovalDetails;
    public profileSearchCache = {
        searchData: null,
        payload: null,
        filteredData: null,
        filter: null,
        sortData: null,
        currentPage: 1,
        totalCount: 0
    };
    private _showToolBar = new BehaviorSubject<boolean>(false);
    showToolBar$ = this._showToolBar.asObservable();

    private _syncMicroAppData = new BehaviorSubject<MicroAppData>(null);
    syncMicroAppData$ = this._syncMicroAppData.asObservable();

    setSyncMicroAppData(data: MicroAppData) {
        this._syncMicroAppData.next(data);
    }


    private _hideHelpContainer = new BehaviorSubject<boolean>(true);
    _hideHelpContainer$ = this._hideHelpContainer.asObservable();

    private _docInfo = new BehaviorSubject<{ infoChangeRequestKey: number, count: number } | null>(null);
    docInfo$ = this._docInfo.asObservable();

    private _workflowHistoryInfo = new Subject<{ infoChangeRequestKey: number } | null>();
    workflowHistoryInfo$ = this._workflowHistoryInfo.asObservable();

    setComponents(profileDataSwitchModel: any) {
        this.profileApprovalComponentSwitches.next({ ...this.profileApprovalComponentSwitches.getValue(), ...profileDataSwitchModel });
    }

    utilityUrl() {
        return armEnvironment.utilityApiEndpoint;
    }
    protected get changeprofileApprovalUrl() {
        return armEnvironment.apiUrl;
    }
    protected get profileApprovalUrl() {
        return armEnvironment.profileApprovalApiEndpoint;
    }
    protected get docUrl() {
        return armEnvironment.utilityApiEndpoint;
    }

    protected getWorkflowUrl() {
        return armEnvironment.easWorkflowApiEndpoint;
    }

    private buildUrl(path: string,) {
        return this.utilityUrl() + path;
    }

    setAccountRequestDetails(AccountRequestDetails: any) {
        this.changeApprovalDetails = AccountRequestDetails;
        this.changeProfileAccountRequestDetails.next(AccountRequestDetails);
    }

    setDuplicatePersonRecords(DuplicatePersonRecords: any) {
        this.duplicatePersonRecords.next(DuplicatePersonRecords);

    }
    readsetAccountRequestDetails() {
        return this.changeApprovalDetails;
    }

    getAccountRequestDetails(changeRequestKey) {
        var url = `${this.changeprofileApprovalUrl}/api/v1/InfoChangeRequestApproval/Detail?`;
        // https://localhost:7007/api/v1/InfoChangeRequestApproval/Detail?infoChangeRequestKey=213
        if (changeRequestKey) {
            return this.http.get(
                `${url}infoChangeRequestKey=${changeRequestKey}`
            );
        }
        else {
            return null
        }
    }

    getDuplicateAccountRequests(accountRequestKey, oaksId) {
        return this.http.get(
            `${this.changeprofileApprovalUrl}/api/v1/AccountApproval/DuplicateAccountRequests?accountRequestKey=${accountRequestKey}&&oaksId=${oaksId}`
        );
    }

    //   getWorkflowStatus(requestKey) {
    //     return this.http.get(`${this.getWorkflowUrl}/api/v5/workflow?applicationKey=233&moduleKey=45&workflowOwnerSourceKey=${requestKey}&workflowOwnerTypeKey=420&workflowTypeKey=230&workflowCompositeOwnerSourceKey=${requestKey}&workflowCompositeOwnerTypeKey=420`)
    //   }

    // getProfileSearchData(payload: ProfileSearchRequest, page: number, pageSize: number, sortBy: string = '', sortOrder: string = ''): Observable<ProfileSearchResponse> {
    //     return this.http.post(`${this.profileApprovalUrl}/api/v1/AccountRequest/Profile/Search?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`, payload).pipe(tap(data => this.setProfileSearchCache(data, payload))) as Observable<ProfileSearchResponse>;
    // }

    getChangeApprovalSearchData(payload: ChangeProfileSearchData, page: number, pageSize: number, sortBy: string = '', sortOrder: string = ''): Observable<ChangeRequestSearchDataResponse> {
        return this.http.post(`${this.changeprofileApprovalUrl}/api/v1/InfoChangeRequestApproval/Search?page=${page}&pageSize=${pageSize}&sortBy=0&sortOrder=0`, payload).pipe(tap(data => this.setProfileSearchCache(data, payload))) as Observable<ChangeRequestSearchDataResponse>;
    }


    //   getUserAccountSearchData(searchNonSafe: boolean): Observable<any[]> {
    //     return this.http.get(`${this.profileApprovalUrl}/api/v1/AccountRequest/Profile/UserAccountSearch?searchNonSafe=` + !!searchNonSafe);
    //   }

    //   createUserAccount(value, isPersonOnly: boolean): Observable<any> {
    //     return this.http.post(`${this.profileApprovalUrl}/api/v1/AccountRequest/CreateUserAccount?isPersonOnly=${isPersonOnly}`, value)
    //   }
    getDocList(context: UtilityContext) {
        const url = `/api/v1/Document/documents?moduleKey=${context.moduleKey}` +
            `&assetTemplateKey=${context.assetTemplateKey}&detailKey=${context.compositeOwnerSourceKey}`
            +
            (context.immediateOwnerSourceKey ?
                `&immediateOwnerSourceKey=${context.immediateOwnerSourceKey}&immediateOwnerTypeKey=${context.immediateOwnerTypeKey}` : '') +
            (context.compositeOwnerTypeKey ?
                `&compositeOwnerTypeKey=${context.compositeOwnerTypeKey}` : '');
        return this.http.get<Docs[]>(this.docUrl + url);
    }

    fetchDocFileByUrl(context: UtilityContext, url: string): Observable<Blob> {
        const fileUrl = this.getDocumentFileUrl(context, url);
        return this.http.getFile(this.buildUrl(`/api/v1/Document/documents/file${fileUrl}`), null)
            .pipe(map((res) => res as Blob))

            .pipe(retry(3));
    }

    getDocumentFileUrl(context: UtilityContext, docUrl: string) {
        const url = `${docUrl}?moduleKey=${context.moduleKey}&assetTemplateKey=${context.assetTemplateKey}` +
            `&detailKey=${context.compositeOwnerSourceKey}` +
            (context.immediateOwnerSourceKey ?
                `&immediateOwnerSourceKey=${context.immediateOwnerSourceKey}&immediateOwnerTypeKey=${context.immediateOwnerTypeKey}` : '') +
            (context.compositeOwnerTypeKey ?
                `&compositeOwnerTypeKey=${context.compositeOwnerTypeKey}` : '');
        return url;
    }


    clearProfileSearchCache() {
        this.profileSearchCache = {
            searchData: null,
            payload: null,
            filteredData: null,
            filter: null,
            sortData: null,
            currentPage: 1,
            totalCount: 0
        };
    }

    setProfileSearchCache(data, payload?, filterData?, filter?, sortData?, currentPage?, totalCount?) {
        if (data)
            this.profileSearchCache.searchData = data;
        if (payload)
            this.profileSearchCache.payload = payload;
        if (filterData)
            this.profileSearchCache.filteredData = filterData;
        if (filter)
            this.profileSearchCache.filter = filter;
        if (sortData)
            this.profileSearchCache.sortData = sortData;
        if (currentPage)
            this.profileSearchCache.currentPage = currentPage;
        if (totalCount)
            this.profileSearchCache.totalCount = totalCount;
    }

    ChangeProfileAccountApproval(data: ManualChangeApprovalModel): Observable<any> {
        return this.http.put(
            `${this.changeprofileApprovalUrl}/api/v1/AccountApproval/ManuallyApproveUserProfileRequest`, data
        );
    }

    showToolBar(status: boolean) {
        this._showToolBar.next(status);
    }

    hideHelpContainer(status: boolean) {
        this._hideHelpContainer.next(status);
    }

    setDocInfo(data) {
        this._docInfo.next({ ...this._docInfo.getValue(), ...data });
    }

    setWorkflowHistoryInfo(data) {
        this._workflowHistoryInfo.next({ ...data });
    }

    private _changeRequestFlags = new BehaviorSubject<number[]>([]);
    changeRequestFlags$ = this._changeRequestFlags.asObservable();

    setAccountRequestFlags(infoChangeRequestFlagKeys: number[]) {
        this._changeRequestFlags.next(infoChangeRequestFlagKeys);
    }

    hasAccessToSensitiveData(): Observable<boolean> {
        return this.http.get(`${this.profileApprovalUrl}/api/v1/AccountRequest/Profile/AccessToSensitiveData`)
    }

    getBMVDetails(driversLicenseNumber: string) {
        return this.http.get(`${this.profileApprovalUrl}/api/v1/AccountRequest/BmvInformation?driverLicenseNumber=${driversLicenseNumber}`)
    }

    //   /**
    //    * Paginated user account search with filter criteria
    //    */
    //   getUserAccountSearchPaginated(payload: any, page: number, pageSize: number): Observable<any> {
    //     return this.http.post(`${armEnvironment.apiUrl}/api/v1/UserProfileManagement/UserAccountSearch?page=${page}&pageSize=${pageSize}`, payload);
    //   }

    //   /**
    //    * Create a new Safe Person (Safe Account)
    //    */
    //   createSafePerson(safePersonRequest: any): Observable<any> {
    //     return this.http.post(
    //       `${armEnvironment.apiUrl}/api/v1/UserProfileManagement/UserAccountPerson`,
    //       safePersonRequest
    //     );
    //   }

    //   /**
    //    * Create a new Oeds Person (Create Person Only)
    //    */
    //   createOedsPerson(personRequest: any): Observable<any> {
    //     return this.http.post(
    //       `${armEnvironment.apiUrl}/api/v1/UserProfileManagement/OedsPerson`,
    //       personRequest
    //     );
    //   }
}
